// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1fyhy","col":"styles_col__1TU-C","fulfillmentStatus":"styles_fulfillmentStatus__2QiWF","emailCol":"styles_emailCol__-JkF4"};